import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  ProgressBar,
  CheckboxList,
  SimpleModal,
  AlertNotice,
  EventDashboardDetails,
} from 'shared/components';
import { isEmpty } from 'lodash';
import { convertKeywords } from 'shared/helpers';

import './TaskContainer.scss';
const toChecklistData = (data) =>
  data.map((item) => ({
    key: item.taskId,
    label: convertKeywords(item.instruction),
    checked: !!item.completedDateTime,
  }));
const filterChecked = (subTasks) => subTasks.filter((el) => el.checked);

const setProgressProps = (task, subtaskOptions, t) =>
  subtaskOptions.length
    ? {
        maxValue: subtaskOptions.length,
        current: filterChecked(subtaskOptions).length,
        total: subtaskOptions.length,
        showNumbersReport: true,
        labelAddon: t('common.labels.completed'),
      }
    : {
        maxValue: 1,
        current: task.completedDateTime ? 1 : 0,
        total: 1,
        labelAddon: t('common.labels.completed'),
        showIncomplete: !task.completedDateTime,
      };

class TaskContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subTaskOptions: props.task.children ? toChecklistData(props.task.children) : [],
      discardModalOpen: false,
      isDirty: false,
    };

    this.updateTask = this.updateTask.bind(this);
    this.onUpdateSubTask = this.onUpdateSubTask.bind(this);
    this.goBack = this.goBack.bind(this);
    this.renderChecklistTask = this.renderChecklistTask.bind(this);
    this.renderSimpleTask = this.renderSimpleTask.bind(this);
  }

  onUpdateSubTask(e) {
    const { subTaskOptions } = this.state;
    subTaskOptions.forEach((elem) => {
      if (elem.key === +e.target.name) {
        elem.checked = e.target.checked;
      }
    });
    this.setState({
      subTaskOptions,
      isDirty: true,
    });
  }

  updateTask() {
    const { subTaskOptions } = this.state;
    const { task } = this.props;

    const tasksList = [];
    let changed;
    if (task.children) {
      subTaskOptions.forEach((opt) => {
        const findTask = task.children.find(
          (t) => t.taskId === opt.key && !!t.completedDateTime !== opt.checked
        );
        if (findTask) {
          changed = true;
        }
        tasksList.push({
          taskId: opt.key,
          completed: opt.checked,
        });
      });
    } else {
      changed = true;
      tasksList.push({
        taskId: task.taskId,
        completed: !task.completedDateTime,
      });
    }
    this.props.updateTask(tasksList, task.category, changed);
  }

  goBack(task) {
    if (this.state.isDirty) {
      this.setState({
        discardModalOpen: true,
      });
    } else {
      this.props.goBack(task);
    }
  }

  closeDiscardModal(goBack) {
    if (goBack) {
      this.props.goBack(this.props.task);
    }
    this.setState({
      discardModalOpen: false,
    });
  }

  renderSimpleTask() {
    const { task, errorUpdate, loadingUpdateTask } = this.props;

    const instruction = convertKeywords(task.instruction);

    return (
      <div className="simple-task-content">
        <div className="container">
          <p dangerouslySetInnerHTML={{ __html: instruction }} />
          {!isEmpty(errorUpdate) && (
            <AlertNotice message={this.props.t('eventChecklist.serverErrorMessage')} type="error" />
          )}
          <button
            className={`${task.completedDateTime ? 'btn-outline' : 'btn-action'} btn ml-0 w-100`}
            onClick={this.updateTask}
            disabled={loadingUpdateTask}>
            {loadingUpdateTask ? (
              <i className="fa fa-spinner fa-spin" />
            ) : task.completedDateTime ? (
              this.props.t('common.labels.undo')
            ) : (
              this.props.t('eventChecklist.completeTaskLabel')
            )}
          </button>
        </div>
        <button className="btn btn-warn mt-4 m-0" onClick={() => this.props.goBack(task)}>
          {this.props.t('common.labels.back')}
        </button>
      </div>
    );
  }

  renderChecklistTask() {
    const { task, errorUpdate, loadingUpdateTask } = this.props;
    const { subTaskOptions } = this.state;
    return (
      <div className="checklist-task-content">
        <CheckboxList
          checkboxes={subTaskOptions}
          onChange={this.onUpdateSubTask}
          title={convertKeywords(task.instruction)}
        />
        {!isEmpty(errorUpdate) && (
          <AlertNotice message={this.props.t('eventChecklist.serverErrorMessage')} type="error" />
        )}
        <div className="buttons-container">
          <button className="btn btn-warn ml-0" onClick={() => this.goBack(task)}>
            {this.props.t('common.labels.back')}
          </button>
          <button
            className="btn mr-0 btn-action"
            disabled={loadingUpdateTask}
            onClick={this.updateTask}>
            {loadingUpdateTask ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              this.props.t('common.labels.save')
            )}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { tcEvent, tcCycle, task } = this.props;
    const { subTaskOptions, discardModalOpen } = this.state;
    const progressProps = task ? setProgressProps(task, subTaskOptions, this.props.t) : {};

    return (
      !!task && (
        <div className="event-task-container">
          <h4>{task.name}</h4>
          <EventDashboardDetails
            date={tcEvent.testingEvent.name}
            name={tcCycle.testCenterProgram.testCenter.name}
          />
          <ProgressBar {...progressProps} />
          {!task.children ? this.renderSimpleTask() : this.renderChecklistTask()}
          <SimpleModal
            isOpen={discardModalOpen}
            onCancel={() => this.closeDiscardModal(false)}
            onConfirm={() => this.closeDiscardModal(true)}
            confirmLabel={this.props.t('common.labels.yes')}
            cancelLabel={this.props.t('common.labels.no')}
            headline={this.props.t('common.backModal.title')}
            message={this.props.t('common.backModal.message')}
            buttonsReverseOrder
          />
        </div>
      )
    );
  }
}

TaskContainer.propTypes = {
  tcCycle: PropTypes.shape({}).isRequired,
  tcEvent: PropTypes.shape({}).isRequired,
  task: PropTypes.shape({}).isRequired,
  errorUpdate: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TaskContainer);
